var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationIcon03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-40.6%",
    y: "-97.1%",
    width: "181.2%",
    height: "294.1%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-76.8%",
    y: "-61.5%",
    width: "253.5%",
    height: "223%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-79.8%",
    y: "-90.1%",
    width: "259.6%",
    height: "280.1%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-81.2%",
    y: "-135.7%",
    width: "262.5%",
    height: "371.3%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.946.354 2.467 5.517c-.694.287-.687 1.273.012 1.55l12.53 4.969a4.65 4.65 0 0 0 3.428 0l12.531-4.97c.698-.276.706-1.262.012-1.549L18.5.353a4.65 4.65 0 0 0-3.555 0",
    fill: "#FCB400",
    filter: "url(#a)",
    transform: "translate(10 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.835 14.75v12.413c0 .59.596.995 1.144.777l13.964-5.42a.836.836 0 0 0 .527-.777V9.33a.836.836 0 0 0-1.144-.778l-13.963 5.42a.836.836 0 0 0-.528.777",
    fill: "#18BFFF",
    filter: "url(#b)",
    transform: "translate(10 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.575 15.39-4.144 2-.421.204-8.748 4.192C.708 22.053 0 21.649 0 21.033V9.382c0-.223.114-.416.268-.56a.95.95 0 0 1 .211-.16.891.891 0 0 1 .76-.058l13.266 5.256c.674.268.727 1.212.07 1.53",
    fill: "#F82B60",
    filter: "url(#c)",
    transform: "translate(10 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.575 15.39-4.144 2L.268 8.823a.95.95 0 0 1 .211-.16.891.891 0 0 1 .76-.058l13.266 5.256c.674.268.727 1.212.07 1.53",
    fillOpacity: 0.25,
    fill: "#000",
    filter: "url(#d)",
    transform: "translate(10 9)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24.946 9.354-12.479 5.163c-.694.287-.687 1.273.012 1.55l12.53 4.969a4.65 4.65 0 0 0 3.428 0l12.531-4.97c.698-.276.706-1.262.012-1.549L28.5 9.353a4.65 4.65 0 0 0-3.555 0",
    fill: "#FCB400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.835 23.75v12.413c0 .59.596.995 1.144.777l13.964-5.42a.836.836 0 0 0 .527-.777V18.33a.836.836 0 0 0-1.144-.778l-13.963 5.42a.836.836 0 0 0-.528.777",
    fill: "#18BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.575 24.39-4.144 2-.421.204-8.748 4.192c-.554.267-1.262-.137-1.262-.753V18.382c0-.223.114-.416.268-.56a.95.95 0 0 1 .211-.16.891.891 0 0 1 .76-.058l13.266 5.256c.674.268.727 1.212.07 1.53",
    fill: "#F82B60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.575 24.39-4.144 2-10.163-8.568a.95.95 0 0 1 .211-.16.891.891 0 0 1 .76-.058l13.266 5.256c.674.268.727 1.212.07 1.53",
    fillOpacity: 0.25,
    fill: "#000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon03);
export default __webpack_public_path__ + "static/media/integration-icon-03.b246bb629de9a54eb641094d87a0f83e.svg";
export { ForwardRef as ReactComponent };